export default __webpack_public_path__ + "static/media/teacher3.bf8afd43.png";